import React from 'react';
import Post from '../render_components/__template_components/post';
import UnknownTemplate from '../render_components/__template_components/unknown_template';
import ArticleCard from '../render_components/__template_components/article_list/article_card';
import PublicationCardV1 from '../render_components/__template_components/cards/publication_card_v1';
import PublicationCardV2 from '../render_components/__template_components/cards/publication_card_v2';
import ItemCardV1 from '../render_components/__template_components/cards/item_card_v1';
import ItemCard from '../render_components/__template_components/item/item_card';
import NewsLine from '../render_components/__template_components/news_line';
import CollectionLine from '../render_components/__template_components/collection_line';
import MainSlider from '../render_components/__template_components/main_slider';
import ContactsV1 from '../render_components/__template_components/contacts_v1';
import Contacts from '../render_components/__template_components/contacts';
import CartV1 from '../render_components/__template_components/cart_v1';
import Cart from '../render_components/__template_components/cart';
import ReviewsV1 from '../render_components/__template_components/reviews_v1';
import ArticleFreeCard from '../render_components/__template_components/article_free';
import Partners from '../render_components/__template_components/partners';

export const renderPublication = (publication, index, globalIndex) => {
  const templateName = publication?.template?.template_name ?? '(нет шаблона)';
  console.log('[renderPublication]', templateName, {
    globalIndex,
    show_name: publication?.show_name,
    eng_name: publication?.eng_name,
  });
  switch (publication.template?.template_name) {
    case 'post':
      return <Post key={index} publication={publication} globalIndex={globalIndex} />;
    case 'article_list':
      return <ArticleCard key={index} publication={publication} globalIndex={globalIndex} />;
    case 'article_free':
      return <ArticleFreeCard key={index} publication={publication} globalIndex={globalIndex} />;
    case 'publication_v1':
      return <PublicationCardV1 key={index} publication={publication} globalIndex={globalIndex} />;
    case 'publication_v2':
      return <PublicationCardV2 key={index} publication={publication} globalIndex={globalIndex} />;
    case 'Publication_1':
      return <PublicationCardV2 key={index} publication={publication} globalIndex={globalIndex} />;
    case 'img_test':
      return <PublicationCardV2 key={index} publication={publication} globalIndex={globalIndex} />;
    case 'item_data_v1':
      return <ItemCardV1 key={index} item={publication} globalIndex={globalIndex} />;
    case 'item':
      return <ItemCard key={index} item={publication} globalIndex={globalIndex} />;
    case 'news_line':
      return <NewsLine key={index} publication={publication} globalIndex={globalIndex} />;
    case 'collection_line':
      return <CollectionLine key={index} publication={publication} globalIndex={globalIndex} />;
    case 'main_slider':
      return <MainSlider key={index} publication={publication} globalIndex={globalIndex} />;
    case 'contacts_v1':
      return <ContactsV1 key={index} publication={publication} globalIndex={globalIndex} />;
    case 'contacts':
      return <Contacts key={index} publication={publication} globalIndex={globalIndex} />;
    case 'cart_v1':
      return <CartV1 key={index} publication={publication} globalIndex={globalIndex} />;
    case 'cart':
      return <Cart key={index} publication={publication} globalIndex={globalIndex} />;
    case 'reviews':
      return <ReviewsV1 key={index} publication={publication} globalIndex={globalIndex} />;
    case 'partners':
    case 'partners_collection':
      return <Partners key={index} publication={publication} globalIndex={globalIndex} />;
    default:
      return (
        <li key={index}>
          <span style={{ fontWeight: 'bold', marginRight: '8px' }}>#{globalIndex}</span>
          {publication.show_name || `Публикация ${globalIndex}`}
        </li>
      );
  }
};
